import { Outlet } from "react-router-dom";

function AddressBookLayout() {
  return <Outlet />;
}

export default AddressBookLayout;
